import { useCallback } from 'react';
import { useUpdateDealPlanMutation } from '../../__generated__/chirp/com/hubspot/deal/plans/rpc/DealPlanPortalRpc.hooks';
import { GET_DEAL_PLAN_QUERY_FIELD_NAME } from '../../__generated__/chirp/com/hubspot/deal/plans/rpc/DealPlanPortalRpc.dfc.new';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { usePortalTracking } from './usePortalTracking';
export function useDealPlanActions(dealPlanId, currentName, dealId) {
  const [updateDealPlan] = useUpdateDealPlanMutation();
  const {
    trackSaveDescription
  } = usePortalTracking(dealId);
  const updateName = useCallback(newName => {
    if (newName !== currentName) {
      void updateDealPlan({
        variables: {
          objectId: dealPlanId,
          name: newName
        },
        optimisticResponse: {
          result: {
            dealPlanId,
            name: newName
          }
        },
        update: cache => {
          cache.modify({
            fields: {
              [GET_DEAL_PLAN_QUERY_FIELD_NAME]: currentDealPlan => Object.assign({}, currentDealPlan, {
                name: newName
              })
            }
          });
        },
        onCompleted: () => {
          FloatingAlertStore.addAlert({
            type: 'success',
            message: I18n.text('dealPlan.milestones.updateSuccess')
          });
        },
        onError: error => {
          console.error(error);
          FloatingAlertStore.addAlert({
            type: 'danger',
            message: I18n.text('dealPlan.updateError')
          });
        }
      });
    }
  }, [currentName, dealPlanId, updateDealPlan]);
  const updateDescription = useCallback(newDescription => new Promise((resolve, reject) => {
    void updateDealPlan({
      variables: {
        objectId: dealPlanId,
        description: newDescription
      },
      update: cache => {
        cache.modify({
          fields: {
            [GET_DEAL_PLAN_QUERY_FIELD_NAME]: currentDealPlan => Object.assign({}, currentDealPlan, {
              description: newDescription
            })
          }
        });
      },
      onCompleted: () => {
        trackSaveDescription();
        FloatingAlertStore.addAlert({
          type: 'success',
          message: I18n.text('dealPlan.richContentBlock.saveSuccess')
        });
        resolve();
      },
      onError: error => {
        console.error(error);
        FloatingAlertStore.addAlert({
          type: 'danger',
          message: I18n.text('dealPlan.updateError')
        });
        reject(error);
      }
    });
  }), [dealPlanId, updateDealPlan, trackSaveDescription]);
  return {
    updateName,
    updateDescription
  };
}